import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import AddCouponForm from "./add-coupon-form";

const propTypes = {
  verifyCouponUrl: PropTypes.string.isRequired,
  applyCouponCodeCallback: PropTypes.func.isRequired,
  couponErrorData: PropTypes.shape({
    code: PropTypes.arrayOf(PropTypes.string)
  }),
  couponData: PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.string,
    status: PropTypes.string,
    partner_id: PropTypes.number,
    discount_cents: PropTypes.number,
    discount_percent: PropTypes.number,
    allow_other_coupons: PropTypes.bool
  }),
  isVerifyingCoupon: PropTypes.bool
};

const AddCouponSection = ({
  verifyCouponUrl,
  applyCouponCodeCallback,
  couponErrorData = {},
  couponData = {},
  isVerifyingCoupon = false
}) => {
  const [toggleCouponForm, setToggleCouponForm] = useState(false);

  useEffect(() => {
    if (couponData?.id) {
      setToggleCouponForm(false);
    }
  }, [couponData]);

  return (
    <div className="block-row apply-coupon-promo-code" id="add-weeks-apply-coupon-promo-code">
      <div className="pb-2">
        Have a coupon code?
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          onClick={() => setToggleCouponForm(!toggleCouponForm)}
          className="pl-1"
          data-testid="open-coupon-form-link"
        >
          Click to apply it.
        </a>
      </div>
      {toggleCouponForm && (
        <AddCouponForm
          setToggleCouponForm={setToggleCouponForm}
          verifyCouponUrl={verifyCouponUrl}
          applyCouponCodeCallback={applyCouponCodeCallback}
          couponErrorData={couponErrorData}
          isVerifyingCoupon={isVerifyingCoupon}
        />
      )}
      <div className="clearfix" />
    </div>
  );
};

AddCouponSection.propTypes = propTypes;

export default AddCouponSection;
